
const ProductPrices = ({ prices, setPrices ,errors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('value', value)
    setPrices((prev) => ({ 
      ...prev, 
      [name]: value ==="" ?null: Number(value)  
    }));
  };
console.log('first', prices.sale_price)
  return (
    <div className="product-prices">
      <h6 className=' mb-2'>أسعار المنتج</h6>
      <div className="row">
        <div className="col-md-4">
          <div className="form-group mb-3">
            <label className="form-label">السعر الأساسي *</label>
            <input
              type="number"
              name="price"
              value={prices.price}
              onChange={handleChange}
              className="form-control"
              placeholder="السعر الأساسي"
              step="0.01"
              min="0"
              required
            />
            {errors?.price &&<span className="error">{errors?.price[0]} </span> }
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="form-group mb-3">
            <label className="form-label">سعر الشراء</label>
            <input
              type="number"
              name="purchase_price"
              value={prices.purchase_price}
              onChange={handleChange}
              className="form-control"
              placeholder="سعر الشراء من المورد"
              step="0.01"
              min="0"
            />
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="form-group mb-3">
            <label className="form-label">السعر بعد الخصم</label>
            <input
              type="text"
              name="sale_price"
              value={prices.sale_price}
              onChange={handleChange}
              className="form-control"
              placeholder="السعر بعد الخصم"
           min="0"
        
            />
          </div>
        </div>
      </div>
      
   
    </div>
  );
};

export default ProductPrices;